import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function BillingReturn() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "checking", plan: null });
  const nav = useNavigate();
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", error: "Session manquante" }); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setState({ status: "paid", plan: data.plan });
          return;
        }
        if (data.status === "expired") {
          setState({ status: "expired" });
          return;
        }
        attempts += 1;
        if (attempts > 12) { setState({ status: "timeout" }); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setState({ status: "error", error: e?.response?.data?.detail || "Erreur" });
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen relative grid place-items-center">
      <div className="starfield" aria-hidden />
      <div className="relative max-w-md w-full mx-auto rounded-md border border-white/10 bg-card p-10 text-center" data-testid="billing-return">
        {state.status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto text-violet-300 animate-spin" />
            <h2 className="mt-5 text-2xl font-light tracking-tight">Confirmation du paiement…</h2>
            <p className="mt-2 text-sm text-muted-foreground">Quelques secondes patience.</p>
          </>
        )}
        {state.status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-400" />
            <h2 className="mt-5 text-2xl font-light tracking-tight">Bienvenue dans AstroLift {state.plan === "annual" ? "Annuel" : "Mensuel"}</h2>
            <p className="mt-2 text-sm text-muted-foreground">Votre forfait est actif. Traitez vos astrophotos sans limite.</p>
            <button onClick={() => nav("/")} className="mt-6 px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm hover:bg-primary/90 glow-violet" data-testid="billing-return-cta">Aller au studio</button>
          </>
        )}
        {(state.status === "expired" || state.status === "timeout" || state.status === "error") && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-red-400" />
            <h2 className="mt-5 text-2xl font-light tracking-tight">Paiement non confirmé</h2>
            <p className="mt-2 text-sm text-muted-foreground">{state.error || "Veuillez réessayer."}</p>
            <button onClick={() => nav("/pricing")} className="mt-6 px-4 py-2 rounded-md border border-white/10 text-sm hover:bg-white/5">Retour aux tarifs</button>
          </>
        )}
      </div>
    </div>
  );
}
